<template>
  <div id="default_layout">
    <header-component />
    <div id="flex-container">
      <sider-component />
      <main-component />
    </div>
    <!--  如果使用foot的话 #flex-container的高度需要再减少50px  -->
    <!--<footer-component />-->
  </div>
</template>

<script>
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import MainComponent from '@/components/layout/MainComponent.vue';
import SiderComponent from '@/components/layout/SiderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import {loginUserStore} from "@/stores/loginUserStore";
import refreshToken from "@/api/refreshToken";

export default {
  components: {
    HeaderComponent,
    MainComponent,
    FooterComponent,
    SiderComponent
  },
  setup() {

  },mounted() {
    // 执行定时刷新token能力
    var intervalRefreshToken = setInterval(async () => {
      const data = await refreshToken();
      console.info(data)
      if(!data){
        clearInterval(intervalRefreshToken);
        console.info(data+"clearInterval(intervalRefreshToken)")
      }
    }, 20*60*1000);
  }
}
</script>

<style scoped>
#flex-container {
  display: flex;
  width: 100%;
  height: calc(100% - 50px);
  border: 1px solid #ebedf0;
}
#default_layout{
  display: flex ;
  flex-direction: column ;
  justify-content: space-between ;
  height: 100%;
}
</style>


